$(function(){
  $("a[href^=http]:not([href*='" + location.hostname + "'])").attr("target", "_blank");
  $(window).scroll(function () {
    var pagetop = $(".footer-pagetop");
    var scrollHeight,scrollPosition,footHeight;
    var bottom = 10;
    if ($(this).scrollTop() > 140) {
      pagetop.fadeIn();
      // ドキュメントの高さ
      scrollHeight = $(document).height();
      // ウィンドウの高さ+スクロールした高さ→ 現在のトップからの位置
      scrollPosition = $(window).height() + $(window).scrollTop();
      // フッターの高さ
      footHeight = $("footer").outerHeight();

      // スクロール位置がフッターまで来たら
      if ( scrollHeight - scrollPosition  <= footHeight ) {
        pagetop.css({"position":"absolute","bottom": footHeight + bottom});
      } else {
        pagetop.css({"position":"fixed","bottom": bottom +"px"});
      }
    } else {
      pagetop.fadeOut();
    }
  });
  $(document).on('click', 'a[href^="#"]', function(e) {
    if ($(this).hasClass('noSmooth')) return;
    e.preventDefault();
    var headerH = $('header').outerHeight() || 0;
    var speed = 1000;
    var href = $(this).attr('href');
    var target = (href === '#' || href === '')
    ? $('html')
    : $(href);
    if (!target.length) return false;
    var position;
    position = target.offset().top;

    $('html, body').animate({
      scrollTop: position
    }, speed);
    return false;
  });
});